import { useUser } from '@cobliteam/hooks';
import { useGetIntercomJWT } from '@cobliteam/hooks/src/useEntity/useSession';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import Intercom from '@intercom/messenger-js-sdk';
import { useCallback } from 'react';

const INTERCOM_APP_ID = 'z9kpl4jw';

export default function useIntercom({ onClose }: { onClose: () => void }) {
  const { getSession } = useUser();
  const session = getSession();
  const featureFlags = useFeatureFlags();
  const { data: intercomJwt } = useGetIntercomJWT({ enabled: !!(featureFlags.blipChat && session) });

  const initIntercom = useCallback(() => {
    if (!(featureFlags.blipChat && session)) return;

    // Boot Intercom even without the JWT so the user can still open the
    // messenger and send a message. When the JWT loads, this effect re-runs
    // and Intercom() acts as an update, attaching identity verification.
    Intercom({
      app_id: INTERCOM_APP_ID,
      name: session.user.name,
      email: session.user.email,
      hide_default_launcher: true,
      ...(intercomJwt && { intercom_user_jwt: intercomJwt }),
      ...(session.user.creationDate && { created_at: Math.floor(session.user.creationDate / 1000) }),
      company: {
        company_id: session.fleet.id,
        name: session.fleet.name,
      },
    });

    window.Intercom?.('onHide', () => {
      onClose();
    });
  }, [featureFlags, session, intercomJwt, onClose]);

  return {
    build: initIntercom,
  };
}
